import {useEffect} from 'react';

/**
 * Cierra un popover/menú al hacer click fuera de él o al presionar Escape.
 *
 * `containerRef` tiene que envolver AL TRIGGER Y AL PANEL: si sólo envuelve el panel, el click que
 * abre el menú cae "afuera" y lo cierra en el mismo evento (el menú parpadea y no abre nunca).
 *
 * Los listeners se montan sólo mientras está abierto, así un listado con 200 filas no tiene 200
 * handlers de `click` en el documento esperando a que alguien abra algo.
 *
 * @param {React.RefObject} containerRef - contenedor que incluye trigger + panel
 * @param {boolean} isOpen
 * @param {Function} onDismiss
 */
export function useDismissOnOutside(containerRef, isOpen, onDismiss) {
    useEffect(() => {
        if (!isOpen) return undefined;

        const closeOnOutsideClick = (event) => {
            if (containerRef.current && containerRef.current.contains(event.target)) return;
            onDismiss();
        };
        const closeOnEscape = (event) => {
            if (event.key === 'Escape') onDismiss();
        };

        document.addEventListener('click', closeOnOutsideClick);
        document.addEventListener('keydown', closeOnEscape);
        return () => {
            document.removeEventListener('click', closeOnOutsideClick);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [containerRef, isOpen, onDismiss]);
}

export default useDismissOnOutside;
